<ng-container *ngIf="translationsReady && translations">
  <app-account-portal-v2 [translations]="translations"></app-account-portal-v2>
</ng-container>

<div *ngIf="!translationsReady" class="loading-translations">
  Loading...
</div>
